import image1 from "../../images/forCourse/image1.jpg";
import image2 from "../../images/forCourse/image2.jpg";
import image3 from "../../images/forCourse/image3.jpg";
import image4 from "../../images/forCourse/image4.jpg";
import image5 from "../../images/forCourse/image5.jpg";
import image6 from "../../images/forCourse/image6.jpg";
import image7 from "../../images/forCourse/image7.jpg";
import image8 from "../../images/forCourse/image8.jpg";
import image9 from "../../images/forCourse/image9.jpg";
import image10 from "../../images/forCourse/image10.webp";


export const sylabus = [
    {
        image: image1,
        description: "ლეგიონის გასაცნობი ღია კარის დღე",
    },
    {
        image: image2,
        description: "სალაშქრო მომზადება, საველე ყოფა და ალგორითმი STOP",
    },
    {
        image: image3,
        description: "პირველი დახმარება",
    },
    {
        image: image4,
        description: "სამთო მომზადება"
    }
    ,
    {
        image: image5,
        description: "ტოპოგრაფია, ორიენტირება და გზის გაგნება"
    }
    ,
    {
        image: image6,
        description: "იარაღის უსაფრთხოება, მსუბუქი ცეცხლსასროლი იარაღი და მებრძოლის აღჭურვილობა"
    },
    {
        image: image7,
        description: "ინდივიდუალური შენიღბვა"
    },
    {
        image: image8,
        description: "ინდივიდუალური და ჯგუფური გადაადგილება"
    }
    ,
    {
        image: image9,
        description: "ბრძოლის ველზე დაკვირვება და პერიმეტრის დაცვა"
    }
    ,
    {
        image: image10,
        description: "ელემენტარული მანევრის ჩატარება"
    }
]